export default {
  slug: "kotlin",
  code: "KT",
  label: "Kotlin",
  isKED: true,
  hasSubtitle: true,
  hasSubtitle2: true,
  krakenDir: "Kotlin",
  logoFamily: "jb",
};
